function cookiePopUp () {
    if(getCookie('cookiePopUp') === undefined) {
        const regionTitle = document.querySelector('.cookie');
        regionTitle.classList.add('cookie-visable');
        const close = regionTitle.querySelector('.cookie__close');
        close.addEventListener('click', function (e) {
            e.preventDefault();
            setCookie('cookiePopUp', true, 360);
            regionTitle.classList.add('cookie-hide');
        });
    }
}
cookiePopUp();